import React, {useEffect, useState} from 'react';
import {Button, CardBody, Col, Form, FormGroup, Input, Table} from 'reactstrap';
import LocalizedStrings from "react-localization";
import {student_strings} from "../../../translations/student_translations";
import Row from "reactstrap/es/Row";
import {resource_strings} from "../../../translations/resource_translations";
import resourceHelper from "../../../helpers/ResourceHelper";
import businessApiService from "../../../api/business-api-service";
import {common_strings} from "../../../translations/common_translations";
import localeHelpers from "../../../helpers/LocaleHelper";
import Label from "reactstrap/es/Label";
import RewardTableRow from "../../Tables/RewardTableRow";
import Select from "react-select";

let commonStrings = new LocalizedStrings(common_strings);
let resourceStrings = new LocalizedStrings(resource_strings);
let studentStrings = new LocalizedStrings(student_strings);

const icons = [
    "001-medal-47", "029-trophy-15", "040-medal-33", "048-trophy-10", "062-trophy-7", "073-trophy-5", "086-medal-12", "099-medal-1", "heart",
    "012-trophy-18", "031-trophy-14", "041-medal-32", "053-shield-1", "063-medal-25", "075-flag", "088-medal-11", "belt-black", "mandala",
    "021-medal-37", "032-crown", "042-medal-31", "054-shield", "065-trophy-6", "077-trophy-4", "089-medal-10", "belt", "rocket",
    "022-medal-36", "033-gold-medal", "043-podium-1", "056-medal-28", "066-medal-23", "080-medal-14", "093-medal-6", "biceps-dumbbell", "shield-1",
    "023-crown-1", "034-trophy-13", "044-trophy-11", "058-trophy-9", "067-medal-22", "082-badge-1", "094-medal-5", "darts", "shield",
    "024-shield-6", "036-file", "046-flags", "060-trophy-8", "069-medal-20", "083-trophy-3", "095-medal-4", "guru-1", "weight",
    "027-diploma", "039-trophy-12", "047-winner", "061-silver-medal", "072-badge-2", "085-trophy-1", "097-medal-3", "guru", "yin-yang"
]

const RewardOverview = (props) => {
    const [show_loader, setShowLoader] = useState(false);
    const [rewards, setRewards] = useState(props.rewards);
    const [classTypes, setClassTypes] = useState(props.classTypes);
    const [reward, setReward] = useState(resourceHelper.emptyReward());
    const [showReward, setShowReward] = useState(false);
    const [selectedClassType, setSelectedClassType] = useState(getClassTypeValue());
    const [classCountValue, setClassCountValue] = useState(getClassCountValue());

    const [value, setValue] = useState(0); // integer state

    useEffect(() => {
        if (reward && props.reward && (reward.class_type_id != props.reward.class_type_id)) {
            setSelectedClassType(getClassTypeValue)
        }
    });

    function localize() {
        const loc = localeHelpers.currentLocale();
        commonStrings.setLanguage(loc);
        studentStrings.setLanguage(loc);
        resourceStrings.setLanguage(loc);
    }

    const deleteReward = (e, reward) => {
        e.preventDefault();

        businessApiService.deleteReward(reward.id)
            .then(res => {
                setRewards(res.rewards);
                setClassTypes(res.class_types);
                setShowReward(false);
            })
            .catch(function (error) {
                console.log(error.toJSON());
            });
    };

    const assignReward = (e, reward) => {
        businessApiService.assignRewardToStudent(reward.id, props.studentId)
            .then(res => {
                props.onStudentRewardUpdated(res)
                setShowReward(false);
            })
            .catch(function (error) {
                console.log(error.toJSON()); // TODO
            });
    }

    const unassignReward = (e, reward) => {
        businessApiService.unassignRewardFromStudent(reward.id, props.studentId)
            .then(res => {
                props.onStudentRewardUpdated(res)
                setShowReward(false);
            })
            .catch(function (error) {
                console.log(error.toJSON()); // TODO
            });
    }

    const editReward = (e, reward) => {
        e.preventDefault();
        setReward(reward);
        setShowReward(true)
    };

    const renderTableData = () => {
        return (rewards || []).map((reward, index) => {
            return (
                <RewardTableRow reward={reward} key={reward.id} deleteReward={deleteReward} editReward={editReward}
                                assignReward={assignReward} unassignReward={unassignReward}
                                studentId={props.studentId}
                                studentRewards={props.studentRewards}
                                showMessage={props.showMessage}
                />
            )
        })
    };

    localize();

    const handleChange = (event) => {
        const r = reward;
        const field = event.target.id
        switch (field) {
            case "input-title":
                r.title = event.target.value
                break
            case "input-description":
                r.note = event.target.value
                break
            case "input-classes-count":
                r.r_type = "class_amount"
                r.class_count = event.target.value
                r.class_type_id = null
                setSelectedClassType(null)
                setClassCountValue(event.target.value)
                break
            default:
                return
        }

        setReward(r)
        setValue(value + 1);
    };

    const closeEditRewardView = e => {
        e.preventDefault();

        setShowReward(false);
        setReward(resourceHelper.emptyReward());
    };

    const startAddingReward = (e) => {
        e.preventDefault();
        setShowReward(true);
    };

    function updateReward(e) {
        e.preventDefault();

        if (reward.id) {
            businessApiService.updateReward(reward)
                .then(res => {
                    setRewards(res.rewards);
                    setClassTypes(res.class_types);
                    setReward(resourceHelper.emptyReward());
                    setShowReward(false);
                    props.onRewardsUpdated(res.rewards)
                })
                .catch(function (error) {
                    console.log(error.toJSON()); // TODO
                });
        } else {
            businessApiService.createReward(reward)
                .then(res => {
                    setRewards(res.rewards);
                    setClassTypes(res.class_types);
                    setReward(resourceHelper.emptyReward());
                    setShowReward(false);
                    props.onRewardsUpdated(res.rewards)
                })
                .catch(function (error) {
                    console.log(error.toJSON()); // TODO
                });
        }
    }

    function setIcon(e, icon) {
        e.preventDefault();
        reward.icon = icon
        setReward(reward)
        setValue(value + 1)
    }

    function createIconPath(icon) {
        return require(`assets/img/icons/rewards/${icon}.svg`);
    }

    const classTypesOptions = () => {
        if (classTypes && classTypes.length > 0) {
            const options = [];
            classTypes.forEach(t => {
                    options.push({value: t.id, label: t.name})
                }
            );

            return options
        } else return [];
    };

    function getClassTypeValue() {
        if (reward.class_type_id) {
            let ct = (classTypes || []).find(it => it.id === reward.class_type_id)
            const ctv = {
                value: ct.id,
                label: ct.name
            }
            return ctv
        } else {

            return ""
        }
    }

    function getClassCountValue() {
        return reward.class_count || ""
    }

    const handleClassTypeSelected = selectedOption => {
        const t = classTypes.find(it => it.id === selectedOption.value);
        const r = reward;
        r.class_type_id = t.id
        r.class_count = ""
        r.r_type = "class_type"

        setSelectedClassType({value: t.id, label: t.name})
        setClassCountValue("")
        setReward(r)
    };

    function removeClassTypeId(e) {
        e.preventDefault()
        const r = reward;
        r.class_type_id = null
        r.r_type = ""

        setSelectedClassType(null)
        setReward(r)
    }

    function showRemoveClassTypeButton() {
        return reward.class_type_id
    }

    return (
        <>
            <Label>{commonStrings.reward_expl}</Label>
            <FormGroup className="mt-0 mb-1 mt-0 text-center">
                {!showReward &&
                <Button
                    color="warning"
                    onClick={e => startAddingReward(e)}
                    size="lg"
                >
                    {commonStrings.add_new_reward}
                </Button>
                }
            </FormGroup>

            {/*Edit reward*/}

            {showReward &&
            <CardBody>
                {/*{reward.teacher_id} {reward.room_id}*/}
                <Form>
                    <div className="pl-lg-4">
                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-title"
                                    >
                                        {resourceStrings.title}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        onChange={handleChange}
                                        placeholder={resourceStrings.reward_placeholder}
                                        defaultValue={reward && reward.title ? reward.title : ""}
                                        id="input-title"
                                        type="text"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                        htmlFor="input-description"
                                    >
                                        {resourceStrings.description}
                                    </label>
                                    <Input
                                        className="form-control-alternative"
                                        onChange={handleChange}
                                        placeholder={commonStrings.bio_expl}
                                        defaultValue={reward && reward.note ? reward.note : ""}
                                        id="input-description"
                                        rows="4"
                                        type="textarea"
                                    />
                                </FormGroup>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg="12">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.icon}
                                    </label>
                                    <Row>
                                        <Col lg="12">
                                            {icons.map((icon, index) => {
                                                return (
                                                    <Button style={{marginRight: '0.5rem', marginTop: '0.5rem'}}
                                                            key={icon}
                                                            color={reward.icon === icon ? "default" : "gray"}
                                                            onClick={e => setIcon(e, icon)}
                                                    >
                                                        <img
                                                            width={24}
                                                            height={24}
                                                            alt=""
                                                            src={createIconPath(icon)}
                                                        />
                                                    </Button>
                                                )
                                            })
                                            }
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>

                        <hr/>

                        {reward.title && reward.icon &&
                        <Row>
                            <Col lg="12" className="mt-4">
                                <FormGroup>
                                    <label
                                        className="form-control-label"
                                    >
                                        {resourceStrings.automatically_assign_for}
                                    </label>
                                    <Row>
                                        <Col style={{display: "flex", alignItems: "center"}}>
                                            <span className="mr-2">{resourceStrings.reward_after_visited}</span>
                                            <span
                                                className="mr-2">
                                            <Input
                                                id="input-classes-count"
                                                onChange={handleChange}
                                                value={classCountValue}
                                                style={{
                                                    textAlign: "center",
                                                    width: "60px",
                                                    height: "24px"
                                                }}/> </span> {resourceStrings.classes_plur}<span
                                            className="ml-3"></span>
                                        </Col>
                                    </Row>

                                    <Row className="mt-4">
                                        <Col>
                                            <span className="mr-2">{resourceStrings.reward_if_visited}</span>
                                            {showRemoveClassTypeButton() &&
                                            <Button
                                                onClick={e => removeClassTypeId(e)}
                                                color="danger" size="sm">
                                                <i className="fas fa-minus text-white"/>
                                            </Button>
                                            }
                                            <Select
                                                style={{minWidth: "100px"}}
                                                className="form-control-alternative"
                                                placeholder={resourceStrings.select_ct}
                                                value={getClassTypeValue()}
                                                onChange={handleClassTypeSelected}
                                                options={classTypesOptions()}
                                            />
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                        </Row>
                        }
                    </div>

                    <Row>
                        <Col lg="12">
                            <Col className="text-right">
                                <Button
                                    color="warning"
                                    outline="button"
                                    size="lg"
                                    onClick={e => closeEditRewardView(e)}
                                >
                                    {commonStrings.close}
                                </Button>

                                <Button
                                    color="default"
                                    size="lg"
                                    disabled={!(reward.title && reward.icon)}
                                    onClick={e => updateReward(e)}
                                >
                                    {commonStrings.save}
                                </Button>
                            </Col>
                        </Col>
                    </Row>

                </Form>
            </CardBody>
            }

            {/*Existing rules*/}
            {!showReward &&
            <Row>
                <Col xl="12">

                    {rewards && rewards.length > 0 &&
                    <Table
                        className="align-items-center table-dark table-flush mt-2"
                        responsive
                    >
                        <tbody>
                        {renderTableData()}
                        </tbody>
                    </Table>
                    }
                </Col>
            </Row>
            }
        </>
    );
};

export default RewardOverview;